import { render, staticRenderFns } from "./IceVehicle.vue?vue&type=template&id=c8f8607c&scoped=true"
import script from "./IceVehicle.vue?vue&type=script&lang=js"
export * from "./IceVehicle.vue?vue&type=script&lang=js"
import style0 from "./IceVehicle.vue?vue&type=style&index=0&id=c8f8607c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f8607c",
  null
  
)

export default component.exports